<template>
  <footer class="footer px-4 ">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted dtac-footer">
          © {{ year }}
          <a
            :href="appUrl"
            class="font-weight-bold ml-1"
            target="_blank"
            >{{ appName }}</a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      appName : process.env.VUE_APP_TITLE,
      appUrl : process.env.VUE_APP_URL

    };
  } 
};
</script>
<style>
.dtac-footer {
  color: #1a1a1a !important;
}
</style>
